// Author Lin
// Date 2021-11-20 09:28:31

class MintalMesPrdPelletizingFilterParameter {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                recordTime = '',
                mixingTankLiquidLevel = '',
                cakeCapacity = '',
                firstNegativePressure = '',
                secondNegativePressure = '',
                thirdNegativePressure = '',
                fourthNegativePressure = '',
                firstBackwashPressure = '',
                secondBackwashPressure = '',
                thirdBackwashPressure = '',
                fourthBackwashPressure = '',
                recorderId = '',
                recorder = '',
                reviewerId = '',
                reviewer = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.recordTime = recordTime;
            this.mixingTankLiquidLevel = mixingTankLiquidLevel;
            this.cakeCapacity = cakeCapacity;
            this.firstNegativePressure = firstNegativePressure;
            this.secondNegativePressure = secondNegativePressure;
            this.thirdNegativePressure = thirdNegativePressure;
            this.fourthNegativePressure = fourthNegativePressure;
            this.firstBackwashPressure = firstBackwashPressure;
            this.secondBackwashPressure = secondBackwashPressure;
            this.thirdBackwashPressure = thirdBackwashPressure;
            this.fourthBackwashPressure = fourthBackwashPressure;
            this.recorderId = recorderId;
            this.recorder = recorder;
            this.reviewerId = reviewerId;
            this.reviewer = reviewer;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdPelletizingFilterParameter();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.recordTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mixingTankLiquidLevel',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.mixingTankLiquidLevel',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'cakeCapacity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.cakeCapacity',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'firstNegativePressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.firstNegativePressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondNegativePressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.secondNegativePressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'thirdNegativePressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.thirdNegativePressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'fourthNegativePressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.fourthNegativePressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'firstBackwashPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.firstBackwashPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'secondBackwashPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.secondBackwashPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'thirdBackwashPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.thirdBackwashPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'fourthBackwashPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.fourthBackwashPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorderId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.recorderId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.recorder',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewerId',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.reviewerId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'reviewer',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.reviewer',
                sortable: true,
                isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            recordTimeRteFilter : '',
            recordTimeLteFilter : '',
            mixingTankLiquidLevelFilter : '',
            cakeCapacityFilter : '',
            firstNegativePressureFilter : '',
            secondNegativePressureFilter : '',
            thirdNegativePressureFilter : '',
            fourthNegativePressureFilter : '',
            firstBackwashPressureFilter : '',
            secondBackwashPressureFilter : '',
            thirdBackwashPressureFilter : '',
            fourthBackwashPressureFilter : '',
            recorderIdFilter : '',
            recorderFilter : '',
            reviewerIdFilter : '',
            reviewerFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.filter.recordTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recordTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.filter.recordTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'recorderFilter',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.filter.recorder',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'recordTime',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.recordTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'mixingTankLiquidLevel',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.mixingTankLiquidLevel',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'cakeCapacity',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.cakeCapacity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'firstNegativePressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.firstNegativePressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondNegativePressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.secondNegativePressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'thirdNegativePressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.thirdNegativePressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'fourthNegativePressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.fourthNegativePressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'firstBackwashPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.firstBackwashPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'secondBackwashPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.secondBackwashPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'thirdBackwashPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.thirdBackwashPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'fourthBackwashPressure',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.fourthBackwashPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'recorder',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.recorder',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'emAclUser'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"recorderId":"id"}'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdPelletizingFilterParameter.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdPelletizingFilterParameter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        